module.exports = __webpack_public_path__ + "img/QCcheckin_S1Page.ca3cfed0.png";